import {ListFilterTrigger} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {TeamFilterMenu} from './TeamFilterMenu';
import {countTeamActiveFilters} from '../../utils';

import type {TeamFilterState} from '../../config/team-filter.config';
import type {FC} from 'react';

export interface TeamFilterProps {
  filter: TeamFilterState;
  onChange: (filter: TeamFilterState) => void;
  disabled?: boolean;
}

export const TeamFilter: FC<TeamFilterProps> = ({filter, onChange, disabled = false}) => {
  const {t} = useTranslation('team');

  return (
    <ListFilterTrigger
      buttonLabel={t('filter.button')}
      activeCount={countTeamActiveFilters(filter)}
      disabled={disabled}
    >
      <TeamFilterMenu filter={filter} onChange={onChange} />
    </ListFilterTrigger>
  );
};
